import { useEffect, useState } from "react";
import PropTypes from "prop-types";

// Components
import SimpleIconButton from "@Layouts/components/Buttons/SimpleIconButton";

// MUI
import { IconButton, Stack, TextField } from "@mui/material";

// Icons
import ClearIcon from "@mui/icons-material/Clear";
import { SearchOnIcon, SearchOffIcon } from "../CustomIcons";

export default function SearchInput(props) {
	const { value, disabled, onChange, onClear } = props;

	// States
	const [isActive, setIsActive] = useState(false);

	useEffect(() => {
		return () => {
			setIsActive(false);
		};
	}, []);

	if (isActive && !disabled) {
		return (
			<Stack direction={"row"} justifyContent={"center"} alignItems={"center"}>
				<TextField
					variant="standard"
					placeholder="Search..."
					autoFocus
					sx={{ width: 155, verticalAlign: "middle" }}
					value={value}
					InputProps={{
						endAdornment: (
							<IconButton title="Clear" aria-label="Clear" size="small" onClick={onClear} disabled={!value}>
								<ClearIcon fontSize="inherit" />
							</IconButton>
						),
					}}
					onChange={onChange}
				/>
				<SimpleIconButton
					onClick={() => {
						setIsActive(false);
						!!value && onClear?.();
					}}
					icon={<SearchOffIcon />}
				/>
			</Stack>
		);
	}

	return <SimpleIconButton disabled={disabled} onClick={() => setIsActive(true)} icon={<SearchOnIcon />} />;
}

SearchInput.propTypes = {
	value: PropTypes.string,
	disabled: PropTypes.bool,
	onClear: PropTypes.func,
	onChange: PropTypes.func,
};
